import _ from "lodash"

export default function initialValues(block) {
  return _.reduce(
    block.fields,
    (acc, field) => {
      if (field.field_type === "checkbox") {
        return {
          ...acc,
          [field.field_name]: [],
        }
      }
      if (field.field_type === "multi_field") {
        return {
          ...acc,
          [field.field_name]: [],
        }
      }
      return {
        ...acc,
        [field.field_name]: "",
      }
    },
    {}
  )
}
